//
//
//
//
//
//
//
//

export default (function (x) { return x.default || x })(require('./autocompleteImpl.js'))



// WEBPACK FOOTER //
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue2-google-maps/dist/components/autocomplete.vue